import React from "react";
import { Helmet } from "react-helmet-async";
import { SEO_CONSTANTS } from "../common/SEOConstants";

const SEO = ({
  title = SEO_CONSTANTS.DEFAULT_TITLE,
  description = SEO_CONSTANTS.DEFAULT_DESCRIPTION,
  keywords = SEO_CONSTANTS.getCombinedKeywords(),
  canonicalUrl,
  ogType = "website",
  ogImage = SEO_CONSTANTS.SITE_LOGO,
  twitterCard = "summary_large_image",
}) => {
  // Build the full canonical URL if a relative path is provided
  const fullCanonicalUrl = canonicalUrl
    ? canonicalUrl.startsWith("http")
      ? canonicalUrl
      : `${window.location.origin}${canonicalUrl}`
    : window.location.href;

  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta
        property="og:image"
        content={`${window.location.origin}${ogImage}`}
      />
      <meta property="og:site_name" content={SEO_CONSTANTS.SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta
        name="twitter:image"
        content={`${window.location.origin}${ogImage}`}
      />

      {/* Other important meta tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content={SEO_CONSTANTS.SITE_NAME} />
    </Helmet>
  );
};

export default SEO;
